import type { ReactNode } from "react";
import { useQuoteDocumentContext } from "./quoteDocumentContext";
import { EMPTY_TEXT_HINT } from "./textPlaceholder";

/**
 * Ghost hint drawn inside an empty text block on the editor canvas, giving it
 * a line box to click and telling the author how to bind a quote field. It is
 * chrome, not content: outside the editor it renders nothing, so the customer
 * page and the PDF show the empty block exactly as authored. The hint takes the
 * click itself - the empty block's own element is the block root, whose tag
 * cannot host a text edit, so a click passing through to it would only select.
 * @returns The hint span in the editor, or null everywhere else
 */
export function EmptyTextPlaceholder(): ReactNode {
  const { editable } = useQuoteDocumentContext();
  if (!editable) {
    return null;
  }
  return (
    <span
      aria-hidden
      className="inline-block min-h-[1em] cursor-text select-none text-gray-400"
    >
      {EMPTY_TEXT_HINT}
    </span>
  );
}
